import { useEffect, useState } from "react";
import { api } from "@/api";
const isDirectSource = (source) => /^(https?:|data:|blob:|\/)/i.test(source || "");
export default function ProtectedImage({ src, alt, className = "", compact = false, ...props }) {
  const [resolvedSrc, setResolvedSrc] = useState(null);
  const [status, setStatus] = useState(src ? "loading" : "empty");
  useEffect(() => {
    let objectUrl; let alive = true;
    if (!src) { setResolvedSrc(null); setStatus("empty"); return undefined; }
    if (isDirectSource(src)) { setResolvedSrc(src); setStatus("ready"); return undefined; }
    setResolvedSrc(null); setStatus("loading");
    api.get(`/files/${src}`, { responseType: "blob" }).then(({ data }) => {
      if (!alive) return; objectUrl = URL.createObjectURL(data); setResolvedSrc(objectUrl); setStatus("ready");
    }).catch(() => { if (alive) setStatus("error"); });
    return () => { alive = false; if (objectUrl) URL.revokeObjectURL(objectUrl); };
  }, [src]);
  if (!resolvedSrc || status === "error") {
    const message = status === "loading" ? "Memuat foto…" : status === "error" ? "Foto tidak dapat dimuat" : "Belum ada foto";
    return <div role={alt ? "img" : undefined} aria-label={alt ? `${message}: ${alt}` : undefined} aria-hidden={alt ? undefined : true} className={`${className} flex flex-col items-center justify-center gap-1 overflow-hidden bg-slate-500/10 p-3 text-center text-xs text-slate-500`} {...props}><span>{message}</span>{!compact && status === "empty" && <span>Gambar menyusul.</span>}</div>;
  }
  return <img src={resolvedSrc} alt={alt} className={className} onError={() => setStatus("error")} {...props} />;
}
